// @flow
import {useEffect} from 'react'
import AppRouter from 'utils/AppRouter'

function RedirectGuestToLogin(): null {
  useEffect(() => {
    AppRouter.instance.redirectTo('/people/sign_in')
  }, [])

  return null
}

export default RedirectGuestToLogin
